import React, { useState, useEffect, useContext } from "react";
import ActionsContext from "common/ActionsContext";
import styled from "styled-components";
import DataTable, { Column } from "common/DataTable";
import Request from "common/Request";
import { askConfirmation, mayDecline } from "common/AskConfirmation";

const doesNothing = () => {};

const NTPStatus = ({ status }) =>
  status !== "warning" && status !== "notice" ? null : (
    <div className="m-t-10 m-b-15">
      <input type="radio" className="radio-col-red" checked={true} />
      <label style={{ cursor: "default" }}>
        <b>
          {status === "warning"
            ? "No NTP servers are synchronizing the date"
            : status === "notice"
            ? "No NTP servers configured"
            : ""}
        </b>
      </label>
    </div>
  );

const serverActions = (_row, send) => [
  {
    id: "send-delete-server",
    label: "Delete",
    icon: "delete",
    onClick: (_value, [_status, server]) => send("delete-server", { server }),
  },
];

const TableContainer = styled.div`
  overflow: auto;
  table.dataTable thead th, table.dataTable tbody td {
    padding: 8px 8px;
  }
`;

const NTPServersList = ({ response, send = doesNothing }) => (
  <TableContainer>
    <DataTable
      pageLength={50}
      exportAsCSV={true}
      content={response}
      columns={[
        Column.Text({
          label: "STATUS",
          idx: 0,
          orderable: false,
        }),
        Column.Text({
          label: "SERVER",
          idx: 1,
          orderable: false,
        }),
        Column.Text({
          label: "REFID",
          idx: 2,
          orderable: false,
        }),
        Column.Text({
          label: "STRATUM",
          idx: 3,
          orderable: false,
        }),
        Column.Text({
          label: "TYPE",
          idx: 4,
          orderable: false,
        }),
        Column.Text({
          label: "WHEN",
          idx: 5,
          orderable: false,
        }),
        Column.Text({
          label: "POLL",
          idx: 6,
          orderable: false,
        }),
        Column.Text({
          label: "REACH",
          idx: 7,
          orderable: false,
        }),
        Column.Text({
          label: "DELAY",
          idx: 7,
          orderable: false,
        }),
        Column.Text({
          label: "OFFSET",
          idx: 8,
          orderable: false,
        }),
        Column.Text({
          label: "JITTER",
          idx: 9,
          orderable: false,
        }),
        Column.Actions({
          label: "ACTIONS",
          idx: 0,
          are: (source, row) => serverActions(row, send),
          colClassName: "text-center action",
          cellClassName: "hides-content-to-operators",
        }),
      ]}
    />
  </TableContainer>
);

const reportIfFailsDuring = (action, process) =>
  process
    .then((response) => {
      if (response) {
        console.log("server.<%s>.error: <%s>", action, response);
        throw `Warning: ${response}`;
      }
    })
    .catch(window.showModalError);

const doRemoveServer = (server) =>
  reportIfFailsDuring("reload", ifCl.run(`clear service ntp server ${server}`));

const removeServer = (server) =>
  askConfirmation(
    `Delete "${server}" server?'`,
    "<b>WARNING</b>: The server will be permanently deleted " +
      "and the NTP service will be restarted.",
    { icon: "location_off" }
  ).then(() => doRemoveServer(server));

const ListNTPServers = () => {
  const [request, setRequest] = useState(null);
  const actions = useContext(ActionsContext);

  const sendSignal = (...args) => actions.send(...args);

  const doRequest = () =>
    Promise.all([
      ifCl.run("show system date status").then((response) => response.trim()),
      ifCl.run("show system ntp"),
    ]).then(([status, response]) => ({ status, response }));

  const doLoad = () => {
    setRequest(doRequest());
  };
  useEffect(
    () =>
      actions.recv("delete-server", ({ server }) =>
        removeServer(server).then(doLoad).catch(mayDecline)
      ),
    []
  );

  useEffect(() => (doLoad(), actions.recv("do-load", doLoad)), []);

  return request === null ? null : (
    <Request during={request}>
      {(result) => (
        <>
          <NTPStatus {...result} />
          <NTPServersList {...result} send={sendSignal} />
        </>
      )}
    </Request>
  );
};

export default ListNTPServers;
